export interface UniqueValuesResponseModel {
  filterApplied: boolean;
  values: Array<string | number | boolean>;
}
